import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { CopyDispatchParameters } from "../models/CopyDispatchParameters";


@Injectable({
    providedIn: 'root'
})
export class DispatchDataService {

    constructor(private http: HttpClient) {

    }

    copyDispatch(copyDispatchParms: CopyDispatchParameters): Observable<CopyDispatchParameters> {
        return this.http.post<CopyDispatchParameters>('api/dispatch/copyDispatch', copyDispatchParms);
    }
}